import { useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import { removeAuth } from "./auth";

function useIdle() {
  const [isIdle, setIsIdle] = useState(null);
  const navigate = useNavigate();

  const handleOnIdle = (event) => {
    setIsIdle(true);
    const currentTime = new Date();
    const formattedCurrentTime = currentTime.toLocaleString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZoneName: "short",
    });

    console.log("Last Active time", getLastActiveTime());
    console.log("Current time", formattedCurrentTime);

    //localStorage.removeItem("user");
    removeAuth();
    navigate("/admin/login");
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 15,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return isIdle;
}

export default useIdle;
